import * as yup from "yup";

const PaymentStepValidation = yup.object().shape({
	pan: yup
		.string()
		.required()
		.test(
			"cardNumberLength",
			"Kredi kartı numarası geçerli formatta olmalıdır.",
			(val) => !val?.includes("_") && val?.length === 19
		),
	cv2: yup
		.string()
		.required()
		.test(
			"securityCodeLength",
			"Güvenlik numarası geçerli formatta olmalıdır.",
			(val) => !val?.includes("_") && val?.length === 3
		),
});

export default PaymentStepValidation;
